import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, Button } from "@mui/material";
import { observer } from "mobx-react-lite";

const WizardFooter = (props: any) => {
  return (
    <Grid container spacing={3}>
      <Grid container>
        <Grid item xs={6} md={6}>
          {/* <Button> Start Over </Button> */}
        </Grid>
        <Grid item xs={6} md={6}>
          {/* <Button>Exit </Button> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

WizardFooter.propTypes = {};

export default observer(WizardFooter);
